import { motion, AnimatePresence } from 'framer-motion'
import { proxy, useSnapshot } from 'valtio'
import { useEffect } from 'react'
import { activeModalStack, miscUiState } from '../globalState'

import { hadModsActivated } from '../clientMods'
import ReplayMainMenu from './ReplayMainMenu'
import { withInjectableUi } from './extendableSystem'

export const mainMenuState = proxy({
  serviceWorkerLoaded: false,
})

// todo clean
let disableAnimation = false
const MainMenuRenderAppBase = () => {
  const haveModals = useSnapshot(activeModalStack).length
  const { gameLoaded, fsReady } = useSnapshot(miscUiState)
  const { state: hadModsActivatedState } = useSnapshot(hadModsActivated)

  const noDisplay = haveModals || gameLoaded || !fsReady || !hadModsActivatedState

  useEffect(() => {
    if (noDisplay && fsReady) disableAnimation = true
  }, [noDisplay])

  return (
    <AnimatePresence>
      {!noDisplay && (
        <motion.div
          initial={false}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: disableAnimation ? 0 : 0.1,
            ease: 'easeInOut'
          }}
        >
          <ReplayMainMenu
            loadReplayAction={() => {
              void import('../browserfs').then(({ openFilePicker }) => {
                openFilePicker('replay')
              })
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default withInjectableUi(MainMenuRenderAppBase, 'mainMenuProvider')
